(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // PLP sticky bar: pin it under the header's main bar and reveal it once the
  // in-page collection header has scrolled out of view. Mirrors the header's
  // own passive-scroll pattern for consistency.
  (function () {
    function init() {
      var bars = document.querySelectorAll('[data-collection-stickybar]');
      if (!bars.length) return;
      var header = document.querySelector('[data-header]');

      function headerHeight() {
        return header ? header.offsetHeight : 0;
      }

      function setTop() {
        var h = headerHeight();
        bars.forEach(function (bar) {
          bar.style.setProperty('--plp-sticky-top', h + 'px');
        });
      }

      function onScroll() {
        var h = headerHeight();
        bars.forEach(function (bar) {
          var root = bar.closest('[data-collection]');
          var anchor = root && root.querySelector('[data-collection-header]');
          if (!anchor) return;
          bar.toggleAttribute('data-visible', anchor.getBoundingClientRect().bottom <= h);
        });
      }

      setTop();
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        setTop();
        onScroll();
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Announcement auto-rotator — vanilla crossfade, no Swiper dependency.
    var rotator = document.querySelector('[data-announcement-rotator]');
    if (rotator) {
      var slides = rotator.querySelectorAll('.announcement-slide');
      if (slides.length > 1) {
        var current = 0;
        setInterval(function () {
          slides[current].removeAttribute('data-active');
          current = (current + 1) % slides.length;
          slides[current].setAttribute('data-active', '');
        }, 4500);
      }
    }
    // Offset the sticky section by the announcement bar's height so only the
    // main bar stays pinned while the top bar scrolls away. Liquid is not
    // rendered in this block, so the section is found via closest().
    var header = document.querySelector('[data-header]');
    var section = header ? header.closest('.shopify-section') : null;
    var announcement = section ? section.querySelector('[data-announcement-bar]') : null;
    if (section) {
      var setAnnouncementH = function () {
        var h = announcement ? announcement.offsetHeight : 0;
        section.style.setProperty('--announcement-h', h + 'px');
      };
      setAnnouncementH();
      window.addEventListener('resize', setAnnouncementH, { passive: true });
    }
    // Shadow on scroll.
    if (header) {
      var onScroll = function () {
        header.toggleAttribute('data-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    Azha.whenLib('Swiper', function (Swiper) {
      document.querySelectorAll('.home-banner-swiper').forEach(function (el) {
        if (el.dataset.inited) return;
        el.dataset.inited = '1';
        var swiper = new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          loop: el.querySelectorAll('.swiper-slide').length > 1,
          speed: 900,
          observer: true,
          observeParents: true,
          watchOverflow: true,
          autoplay:
            parseInt(el.dataset.bannerAutoplay, 10) > 0
              ? { delay: parseInt(el.dataset.bannerAutoplay, 10), disableOnInteraction: false }
              : false,
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
          navigation: {
            prevEl: el.querySelector('.home-banner-prev'),
            nextEl: el.querySelector('.home-banner-next'),
          },
        });
        // Recalculate once banner images have loaded so the right peek renders.

        window.addEventListener('load', function () {
          swiper.update();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-offers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function flash(btn) {
      var label = btn.querySelector('[data-copy-label]');
      if (!label) return;
      label.textContent = btn.dataset.copiedLabel || 'Copied';
      btn.dataset.copied = '1';
      setTimeout(function () {
        label.textContent = btn.dataset.codeLabel || '';
        btn.removeAttribute('data-copied');
      }, 1600);
    }

    document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.dataset.copied) return;
        var code = btn.getAttribute('data-copy-code') || '';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () { flash(btn); }).catch(function () { flash(btn); });
        } else {
          flash(btn);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    Azha.whenLib('Swiper', function (Swiper) {
      document.querySelectorAll('.home-products-slider').forEach(function (root) {
        var el = root.querySelector('.home-products-swiper');
        if (!el || el.dataset.inited) return;
        el.dataset.inited = '1';
        new Swiper(el, {
          slidesPerView: 2.3,
          spaceBetween: 5,
          centerInsufficientSlides: true,
          speed: 600,
          grabCursor: true,
          navigation: {
            prevEl: root.querySelector('.home-products-prev'),
            nextEl: root.querySelector('.home-products-next'),
          },
          breakpoints: {
            640: { slidesPerView: 2.5, spaceBetween: 10 },
            768: { slidesPerView: 3.1, spaceBetween: 12 },
            1024: { slidesPerView: 3.5, spaceBetween: 13 },
            1280: { slidesPerView: 4.5, spaceBetween: 14 },
            1536: { slidesPerView: 5.5, spaceBetween: 16 },
          },
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = function (tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    };

    function buildStars(rating) {
      var wrap = el('div', 'review-stars');
      var full = Math.round(rating || 0);
      for (var i = 1; i <= 5; i++) {
        var s = el('span', i <= full ? 'text-amber-500' : 'text-border', i <= full ? '★' : '☆');
        wrap.appendChild(s);
      }
      return wrap;
    }

    function decodeEmojiShortcodes(value) {
      var emoji = {
        fire: '🔥', evergreen_tree: '🌲', heart: '❤️', red_heart: '❤️',
        heart_eyes: '😍', smile: '😄', blush: '😊', sparkles: '✨',
        star: '⭐', tada: '🎉', '100': '💯', thumbs_up: '👍',
        '+1': '👍', clap: '👏', rose: '🌹', sun: '☀️',
        sunglasses: '😎', green_heart: '💚', blue_heart: '💙'
      };
      return (value || '').replace(/:([a-z0-9_+-]+):/gi, function (match, name) {
        return emoji[name.toLowerCase()] || '';
      }).replace(/\s+/g, ' ').trim();
    }

    // Shopify auto-generates product handles from titles using this same
    // shape: lowercase, non-alphanumeric → '-', collapsed, trimmed. Matches
    // ~99% of real handles, so a constructed link usually resolves. Wrong
    // guesses 404 cleanly rather than misroute.
    function slugify(s) {
      return (s || '').toLowerCase().normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')          // strip combining diacritics
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function safeImage(src) {
      // Only allow Shopify CDN images — defends against a hostile widget
      // payload trying to render a tracking pixel or arbitrary URL.
      return /^https:\/\/cdn\.shopify\.com\//.test(src || '') ? src : '';
    }

    function buildProductCard(r) {
      if (!r.product) return null;
      var slug = slugify(r.product);
      if (!slug) return null;
      var a = document.createElement('a');
      a.href = '/products/' + slug;
      a.className = 'mt-4 flex items-center gap-3 rounded-card border border-border bg-sand/30 p-3 transition hover:bg-sand/60';
      var img = safeImage(r.productImage);
      if (img) {
        var i = document.createElement('img');
        i.src = img; i.alt = r.product;
        i.loading = 'lazy'; i.decoding = 'async';
        i.width = 56; i.height = 56;
        i.className = 'h-14 w-14 flex-none rounded-card object-cover';
        a.appendChild(i);
      }
      var info = el('div', 'min-w-0 flex-1');
      info.appendChild(el('p', 'text-[10px] uppercase tracking-wide text-muted', 'Shop'));
      info.appendChild(el('p', 'truncate font-heading text-sm text-primary', r.product));
      a.appendChild(info);
      return a;
    }

    function buildCard(r, readMore, readLess) {
      var slide = el('div', 'swiper-slide');
      var fig = el('figure', 'flex h-full flex-col rounded-card border border-border bg-background p-6');
      fig.appendChild(buildStars(r.rating || 5));
      if (r.title) fig.appendChild(el('p', 'mt-2 font-heading text-lg text-primary', r.title));
      var body = r.body || '';
      var preview = body.length > 240 ? body.slice(0, 240).replace(/\s+\S*$/, '') : body;
      if (!preview) preview = body.slice(0, 240);
      var quote = el('blockquote', 'mt-2 flex-1 text-sm leading-relaxed text-primary/80', body.length > 240 ? preview + '…' : body);
      fig.appendChild(quote);
      if (body.length > 240) {
        var button = el('button', 'review-expand', readMore);
        button.type = 'button';
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          quote.textContent = expanded ? preview + '…' : body;
          button.textContent = expanded ? readMore : readLess;
          button.setAttribute('aria-expanded', String(!expanded));
        });
        fig.appendChild(button);
      }
      fig.appendChild(el('figcaption', 'mt-4 text-xs font-medium uppercase tracking-wide text-muted', r.reviewer || 'Verified buyer'));
      var card = buildProductCard(r);
      if (card) fig.appendChild(card);
      slide.appendChild(fig);
      return slide;
    }

    function textOf(item, sel) {
      var n = item.querySelector(sel);
      return n ? (n.textContent || '').trim().replace(/\s+/g, ' ') : '';
    }

    function ratingOf(item) {
      var r = item.querySelector('.jdgm-carousel-item__review-rating[aria-label]');
      var m = r && (r.getAttribute('aria-label') || '').match(/\d+/);
      return m ? parseInt(m[0], 10) : 0;
    }

    function productImageOf(item) {
      var img = item.querySelector('.jdgm-carousel-item__product-image');
      return img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '';
    }

    function resolveShop(fromLiquid) {
      // Liquid's shop.permanent_domain returns the request host (e.g.
      // `localhost:9292`) under `shopify theme dev`, so only trust it when it
      // actually looks like a .myshopify.com domain. Fall back to the global
      // Shopify object, which the storefront injects with the real canonical
      // shop in every context including dev previews.
      if (fromLiquid && /\.myshopify\.com$/.test(fromLiquid)) return fromLiquid;
      var fromGlobal = window.Shopify && window.Shopify.shop;
      if (fromGlobal && /\.myshopify\.com$/.test(fromGlobal)) return fromGlobal;
      return '';
    }

    document.querySelectorAll('[data-reviews]').forEach(function (root) {
      var token = root.dataset.token;
      var shop = resolveShop(root.dataset.shop);
      var track = document.querySelector('[data-reviews-track]');
      var status = document.querySelector('[data-reviews-status]');
      var wrap = document.querySelector('[data-reviews-wrap]');
      if (!root || !track) return;
      // Status string is shown on-page only in the theme editor (data-debug).
      // On the live storefront we keep failures silent for shoppers but still
      // log to the console so devs can diagnose without leaking internals.
      var debug = root.hasAttribute('data-debug');
      var setStatus = function (msg) {
        if (msg) console.warn('[home-reviews]', msg);
        if (!status || !debug) return;
        status.textContent = msg || '';
        status.classList.toggle('hidden', !msg);
      };
      if (!token) return; // Skeleton stays; merchant must add a token.
      if (!shop) {
        setStatus('Could not determine the shop\'s .myshopify.com domain. Set the section\'s Shop domain setting explicitly.');
        return;
      }

      function loadReviews() {
        if (root.dataset.loaded) return;
        root.dataset.loaded = 'true';
        var url = 'https://api.judge.me/api/v1/widgets/featured_carousel'
          + '?shop_domain=' + encodeURIComponent(shop)
          + '&api_token=' + encodeURIComponent(token);

        fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('judge.me returned HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var html = data && data.featured_carousel;
          track.replaceChildren();
          if (!html) {
            setStatus('judge.me returned no featured carousel HTML — add reviews to the Featured Reviews carousel in judge.me admin.');
            return;
          }
          // DOMParser is sandboxed — scripts in the parsed doc don't execute.
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.jdgm-carousel-item');
          if (!items.length) {
            setStatus('judge.me carousel is empty (' + html.length + ' bytes returned, no .jdgm-carousel-item nodes).');
            return;
          }
          var min = parseInt(root.dataset.minRating, 10) || 0;
          var max = parseInt(root.dataset.perPage, 10) || 12;
          var reviews = [];
          items.forEach(function (item) {
            var rating = ratingOf(item);
            var body = textOf(item, '.jdgm-carousel-item__review-body');
            var product = textOf(item, '.jdgm-carousel-item__product-title');
            // Skip shop reviews (no product attached) — we only render product reviews.
            if (!product || rating < min || !body) return;
            reviews.push({
              rating: rating,
              title: decodeEmojiShortcodes(textOf(item, '.jdgm-carousel-item__review-title')),
              body: decodeEmojiShortcodes(body),
              reviewer: textOf(item, '.jdgm-carousel-item__reviewer-name'),
              product: product,
              productImage: productImageOf(item)
            });
          });
          if (!reviews.length) {
            setStatus('Found ' + items.length + ' review(s) but none passed the rating/body filter (min=' + min + ').');
            return;
          }
          // Longest reviews first, then lead with one review per distinct
          // product before repeating a product — surfaces the most
          // substantial, varied reviews ahead of shorter/duplicate ones.
          reviews.sort(function (a, b) { return b.body.length - a.body.length; });
          var seenProducts = {};
          var uniqueFirst = [];
          var repeats = [];
          reviews.forEach(function (r) {
            if (seenProducts[r.product]) {
              repeats.push(r);
            } else {
              seenProducts[r.product] = true;
              uniqueFirst.push(r);
            }
          });
          reviews = uniqueFirst.concat(repeats).slice(0, max);
          setStatus('');
          reviews.forEach(function (r) {
            track.appendChild(buildCard(r, root.dataset.readMore, root.dataset.readLess));
          });
          // Move track container to the full-bleed wrap so it renders edge-to-edge
          if (wrap) {
            var sw = wrap.querySelector('.reviews-swiper');
            if (sw) {
              Azha.whenLib('Swiper', function (Swiper) {
                // Resolve the computed pixel value of --gutter (it's a clamp(), so we read
                // it off a live element rather than trying to parseInt the raw CSS value).
                var tmp = document.createElement('div');
                tmp.style.cssText = 'position:absolute;visibility:hidden;width:var(--gutter)';
                document.body.appendChild(tmp);
                var gutter = tmp.offsetWidth || 20;
                document.body.removeChild(tmp);
                new Swiper(sw, {
                  slidesPerView: 'auto',
                  spaceBetween: window.innerWidth < 640 ? 10 : 20,
                  centerInsufficientSlides: true,
                  speed: 600,
                  grabCursor: true,
                  slidesOffsetBefore: gutter,
                  slidesOffsetAfter: gutter,
                });
              });
            }
          }
        })
          .catch(function (err) {
            track.replaceChildren();
            setStatus('Could not load judge.me reviews: ' + (err && err.message ? err.message : err) + '. If the storefront uses a custom domain, register it in judge.me admin so CORS allows the request.');
          });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          observer.disconnect();
          loadReviews();
        }, { rootMargin: '500px 0px' });
        observer.observe(root);
      } else {
        loadReviews();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-seasonal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeAll(except) {
      document.querySelectorAll('.seasonal-hotspot.is-open').forEach(function (hs) {
        if (hs === except) return;
        hs.classList.remove('is-open');
        var btn = hs.querySelector('.seasonal-hotspot__dot');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function initBanner(banner) {
      if (banner.dataset.hotspotInit) return;
      banner.dataset.hotspotInit = '1';
      banner.querySelectorAll('[data-seasonal-hotspot]').forEach(function (hs) {
        var dot = hs.querySelector('.seasonal-hotspot__dot');
        if (!dot) return;
        dot.addEventListener('click', function () {
          var willOpen = !hs.classList.contains('is-open');
          closeAll(hs);
          hs.classList.toggle('is-open', willOpen);
          dot.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.seasonal-banner').forEach(initBanner);
    }

    if (!window.__seasonalHotspotBound) {
      window.__seasonalHotspotBound = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-seasonal-hotspot]')) return;
        closeAll(null);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll(null);
      });
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    Azha.whenLib('Swiper', function (Swiper) {
      document.querySelectorAll('.home-video-slider').forEach(function (root) {
        var el = root.querySelector('.home-video-swiper');
        if (!el || el.dataset.inited) return;
        el.dataset.inited = '1';

        new Swiper(el, {
          slidesPerView: 1.4,
          spaceBetween: 12,
          centerInsufficientSlides: true,
          speed: 600,
          grabCursor: true,
          loop: el.querySelectorAll('.swiper-slide').length > 6,
          navigation: {
            prevEl: root.querySelector('.home-video-prev'),
            nextEl: root.querySelector('.home-video-next'),
          },
          breakpoints: {
            640: { slidesPerView: 3, spaceBetween: 16 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
            1280: { slidesPerView: 5, spaceBetween: 20 },
            1536: { slidesPerView: 6, spaceBetween: 24 },
          },
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
